import { TFunction } from '@lyearn/i18n';
import { PropertiesToDuplicateEnum } from '@/types/schema';

import { ListDuplicationFormPropertiesType } from './components/Editor/config';

export const getTaskPropertiesToDuplicateOptions = (t: TFunction) => [
  {
    label: t('Task:DuplicationProperties.DueDate'),
    value: PropertiesToDuplicateEnum.DueDate,
  },
  {
    label: t('Task:DuplicationProperties.Assignees'),
    value: PropertiesToDuplicateEnum.Assignees,
  },
  {
    label: t('Task:DuplicationProperties.Priority'),
    value: PropertiesToDuplicateEnum.Priority,
  },
  {
    label: t('Task:DuplicationProperties.Tags'),
    value: PropertiesToDuplicateEnum.Tags,
  },
  {
    label: t('Task:DuplicationProperties.Status'),
    value: PropertiesToDuplicateEnum.Status,
  },
  {
    label: t('Task:DuplicationProperties.Stages'),
    value: PropertiesToDuplicateEnum.Stages,
  },
  {
    label: t('Task:DuplicationProperties.Subtasks'),
    value: PropertiesToDuplicateEnum.SubTasks,
  },
];

export enum ListPropertiesToDuplicateEnum {
  ListSettings = 'ListSettings',
  ListMembers = 'ListMembers',
}

export const getListPropertiesToDuplicateOptions = (t: TFunction) => [
  {
    label: t('Task:DuplicateList.ListSettings'),
    value: ListPropertiesToDuplicateEnum.ListSettings,
  },
  {
    label: t('Task:DuplicateList.ListMembers'),
    value: ListPropertiesToDuplicateEnum.ListMembers,
  },
];

const ProjectSettingsProperties = [
  PropertiesToDuplicateEnum.DueDate,
  PropertiesToDuplicateEnum.Assignees,
  PropertiesToDuplicateEnum.Status,
  PropertiesToDuplicateEnum.Stages,
  PropertiesToDuplicateEnum.VisibilitySettings,
  PropertiesToDuplicateEnum.Client,
];

export const adaptPropertiesForMutation = (properties: ListDuplicationFormPropertiesType) => {
  const { listPropertiesToDuplicate, actionItemPropertiesToDuplicate } = properties;
  const propertiesToDuplicate = [];

  if (actionItemPropertiesToDuplicate.length) {
    propertiesToDuplicate.push(PropertiesToDuplicateEnum.Task);
  }

  if (listPropertiesToDuplicate.includes(ListPropertiesToDuplicateEnum.ListSettings)) {
    propertiesToDuplicate.push(...ProjectSettingsProperties);
  } else if (actionItemPropertiesToDuplicate.includes(PropertiesToDuplicateEnum.Stages)) {
    // if project settings is not selected but stages is selected in action items
    propertiesToDuplicate.push(PropertiesToDuplicateEnum.Stages);
  }

  // TODO - after (and if) we implement List Members feature
  // if (listPropertiesToDuplicate.includes(ListPropertiesToDuplicateEnum.ListMembers)) {
  // Push whatever property is required to duplicate list members
  // }

  // always duplicate Media
  propertiesToDuplicate.push(PropertiesToDuplicateEnum.Media);

  return {
    propertiesToDuplicate,
    actionItemPropertiesToDuplicate,
  };
};
